'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import { NavigationGuardProvider } from 'next-navigation-guard';

interface Props {
  children: React.ReactNode;
}

export default function ConditionalNavigationGuardProvider({ children }: Props) {
  const pathname = usePathname();

  // Define the paths to exclude
  const pathsToExclude = [
    '/settings',
  ];

  // Check if the current pathname starts with any of the excluded paths
  const isExcluded = pathsToExclude.some((path) => pathname?.startsWith(path));

  if (isExcluded) {
    // Do not wrap with NavigationGuardProvider
    return <>{children}</>;
  }

  // Wrap with NavigationGuardProvider
  return (
    <NavigationGuardProvider>
      {children}
    </NavigationGuardProvider>
  );
}
